import { AnimatePresence, motion } from "framer-motion";
import { FC } from "react";

export type MobileDrawerWithTextAndImageProps = {
  title: React.ReactNode;
  description: string | React.ReactNode;
  image: React.ReactNode;
  onClickCallback: () => void;
  isActive: boolean;
  titleTextColor: string;
  textColor: string;
  iconColor: string;
  borderColor: string;
}

const MobileDrawerWithTextAndImage: FC<MobileDrawerWithTextAndImageProps> = ({ title, description, image, isActive, onClickCallback, titleTextColor, textColor, iconColor, borderColor }) => {
  return (
    <div className={`flex flex-col w-full flex-wrap cursor-pointer first:border-t border-b border-solid ${borderColor}`}
      onClick={onClickCallback}>
      <motion.div
        className={`flex w-full justify-between font-500 text-p1 pt-[24px] ${titleTextColor}`}
        initial={{ paddingBottom: '24px' }}
        animate={isActive ? { paddingBottom: '4px' } : { paddingBottom: '24px' }}
        transition={{
          duration: 0.4,
          ease: 'easeInOut',
        }}
      >
        <div className="flex">
          {title}
        </div>
        <div className="flex">
          {/* Animated plus sign - vertical line is rotate 90deg when active to create minus sign */}
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 28 28" fill="none">
            <motion.path d="M14 9.33333V18.6667" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
              animate={isActive ? { transform: 'rotate(90deg)' } : { transform: 'rotate(0deg)' }}
              transition={{
                duration: 0.4,
                ease: 'easeInOut',
              }} />
            <path
              d="M9.3335 14H18.6668" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
            />
          </svg>
        </div>
      </motion.div>

      <motion.div
        className={`overflow-hidden `}
        initial={false}
        animate={{ height: isActive ? 'auto' : 0 }}
        transition={{
          duration: 400 / 1000,
          ease: 'easeInOut',
        }}
      >
        <div className={`flex ${textColor} flex-wrap text-p2 pb-[32px] justify-center`}>
          {description}
          {/* Using AnimatePresence to avoid loading the image when the feature is not active */}
          <AnimatePresence>
            {isActive && (
              <motion.div
                className="flex mt-[16px]"
                initial={false}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.4,
                  ease: 'easeInOut',
                }}
              >
                {image}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
};

export default MobileDrawerWithTextAndImage;
